import { startCase } from "lodash";
import { useNavigate } from "react-router-dom";
import { Avatar, Grid2 as Grid, TableBody, TableCell, TableRow } from "@mui/material";
import { Order } from "../../../../../../typings/types";
import { getComparator, stableSort } from "../../../../custom-components/table-helper/helperTable";
import { useAuth } from "../../../../../context/AuthContext";

interface Props {
  rows: any[];
  order: Order;
  orderBy: string;
}

export const StudentPerformanceTableRows = ({ rows, order, orderBy }: Props) => {
  const navigate = useNavigate();

  const { baseRole: role } = useAuth();

  return (
    <>
      <TableBody>
        {stableSort(rows, getComparator(order, orderBy))?.map((row: any) => {
          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={row.id}
              className="pointer"
              onClick={() => navigate(`/${role}/students/${row.id}/performance`)}
            >
              {/* Every field lives under the `attributes.*` envelope the metrics
                  hook returns. The flat `row.semsester_avg` / `row.gpa` reads
                  below used to resolve to undefined and render an empty cell. */}
              <TableCell align="left" sx={{ minWidth: "250px" }}>
                <Grid container sx={{ alignItems: "center", flexWrap: "nowrap" }} spacing={2}>
                  <Avatar
                    alt={row?.attributes?.first_name}
                    src={row?.attributes?.profile_url?.url}
                  />
                  <Grid>
                    {startCase(
                      `${row?.attributes?.first_name ?? ""} ${row?.attributes?.last_name ?? ""}`,
                    ).trim() || "—"}
                  </Grid>
                </Grid>
              </TableCell>

              {/* semsester_avg is already 0-100 and gpa is a configured band
                  label ("Very Good") — percentFormat would ×100 the first and
                  render NaN% for the second. */}
              <TableCell align="left" sx={{ minWidth: "100px" }}>
                {row?.attributes?.semsester_avg == null
                  ? "—"
                  : `${row.attributes.semsester_avg}%`}
              </TableCell>

              <TableCell align="left" sx={{ minWidth: "100px" }}>
                {row?.attributes?.gpa ?? "—"}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </>
  );
};
